/**
 * LES CLES D'ONGLETS DU HUB PARAMETRES (`/settings?t=<cle>`), et la table des
 * anciennes. Module PUR, sans React ni `import.meta.env` : le hub et la route
 * du shell (`validateSettingsSearch`) le lisent tous les deux, et un test Node
 * l'importe tel quel. Une cle d'onglet est un contrat : un lien pose ailleurs
 * (un mail, la doc, un favori) la cite.
 */

/** L'onglet « Conversations » : canaux, fenetre de chat, Lia (ex-« IA »). */
export const CONVERSATIONS_MENU_ID = 'conversations';

/** L'onglet « Apps installées » : la liste de l'org et l'environnement (bande STAGING). */
export const INSTALLATION_MENU_ID = 'apps';

/** L'onglet « Notifications ». */
export const NOTIFICATIONS_MENU_ID = 'notifications';

/**
 * UNE CLE RENOMMEE NE CASSE AUCUN LIEN : elle reste ici, pointee sur sa
 * remplacante. `ia` est l'onglet « IA » d'avant le 06/10/2026, devenu
 * « Conversations » (il regroupe desormais les canaux et la fenetre de chat).
 */
export const ONGLETS_REDIRIGES: Readonly<Record<string, string>> = {
  ia: CONVERSATIONS_MENU_ID,
};

/** La cle a ouvrir pour une cle lue dans l'adresse : l'ancienne devient la nouvelle. */
export function cleDOnglet(cle: string): string {
  return Object.hasOwn(ONGLETS_REDIRIGES, cle) ? ONGLETS_REDIRIGES[cle]! : cle;
}
